// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.service-header-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.service-header-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.service-header-reating {
    display: flex;
    align-items: center;
    gap: 10px;
}

.service-header-reating img {
    width: 33px;
}

.service-header-left h3 {
    font-size: 38px;
    color: #1A1919;
    font-weight: bold;
    margin: 0px;
    /* margin-bottom: 14px; */
}

.service-header-reating p {
    font-size: 20px;
    color: #626262;
    font-weight: 400;
    margin: 0px;
}

.service-right-nav {
    display: flex;
    align-items: center;
    gap: 14px;
}

.service-right-nav p {
    font-size: 16px;
    color: #9E9E9E;
    font-weight: 600;
    margin: 0px;
}

.service-right-nav img {
    width: 6px;
}

.service-right-nav h6 {
    font-size: 16px;
    color: #00A19B;
    font-weight: 600;
    margin: 0px;
}

.dashboard-service-detail-wrapper {
    margin-top: 25px;
}

.address-detail-wrap {
    width: 100%;
    height: 259px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 30px 34px;
}

.address-detail-wrap .field{
    margin-bottom: 14px;
}

.address-detail-wrap h4 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    margin-left: 10px;
}

.service-select-wrap{
    width: 100%;
    height: 444px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 32px 36px;
    margin-top: 20px;
}

.home-service-detail-main-wrap {
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    /* min-height: 72vh; */
    padding: 25px 40px;
}

.address-form-input-wrapper{
    margin-top: 10px;
}

.address-form-input-wrap{
    position: relative;
    width: 100%;
    height: 62px;
    margin-bottom: 16px;
}

.address-form-input-wrap input {
    width: 100%;
    height: 62px;
    border: 1px solid #F3F3F3;
    border-radius: 9px;
    padding-left: 25px;
    padding-top: 20px;
    outline: none;
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
}

.address-form-input-wrap input::placeholder{
    color: #1A1919; 
}

.login-form-textarea-wrap{
    height: 236px;  
}


.address-form-input-wrap label {
    position: absolute;
    top: 10px;
    left: 25px;
    font-size: 12px;
    font-weight: 400;
    color: #626262;
}

.service-select-images {
    display: flex;
    justify-content: space-between;
}

.service-select-images img {
    width: 92px;
}

/* .service-select-dropdown-wrap {
    margin-top: 28px;
} */

.service-select-dropdown-wrap h4 {
    font-size: 22px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
    margin-left: 10px;
}

.empty-service-wrapper {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
    min-height: 58vh;
    align-items: center;
}

.empty-service-wrapper img {
    width: 170px;
}

.empty-service-wrapper p {
    font-size: 16px;
    color: #9E9E9E;
    font-weight: 600;
    margin: 0px;
    font-style: italic;
}

.selected-service-title{
    margin-top: -60px;
    margin-bottom: 20px;
    padding-left: 40px;
}

.selected-service-title h3{
    font-size: 30px;
    color: #1A1919;
    font-weight: bold;
    margin: 0px;
}

.selected-service-detail-wrap {
    display: grid;
    /* grid-template-columns: auto auto; */
    grid-template-columns: 50% 50%;
    gap: 20px;
}

.selected-service-detail-wrap.fullscreen {
    grid-template-columns: 100%;
}

.selected-service-detail-left{
    width: 100%;
    border-right: 1px solid #F3F3F3;
    padding-right: 20px;
}

.special-service-detail-left{
    padding-right: 0px !important;
}

.selected-service-detail-right{
    width: 100%;
    position: relative;
    /* height: 670px;
    overflow: auto; */
}

.home-sequare-feet-wrap h4
 {
    font-size: 18px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    padding-bottom: 16px;
    padding-left: 10px;
}

.cleaning-persentage-info {
    display: flex;
    align-items: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.cleaning-persentage-info h4
 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    padding-left: 10px;
}

.cleaning-persentage-info img{
    cursor: pointer;
}

.service-item-card-wrapper {
    margin-top: 10px;
    gap: 20px;
}

.service-item-card-wrapper.additional-services-card-wrap {
    margin-top: 12px;
}

.service-items-main-wrap {
    margin-top: 20px;
}

.service-items-main-wrap h5{
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    padding-bottom: 3px;
    padding-left: 10px;
}

.service-item-card-wrap {
    width: 103px !important;
    height: 134px;
    border: 1px solid #F3F3F3;
    border-radius: 15px;
    padding: 6px 12px;
    position: relative;
    transition: transform 0.3s ease;
}

.service-item-image {
    position: relative;
    height: 78px;
    width: 78px;
}

.service-item-img{
    /* padding-top: 10px; */
    height: 78px;
    width: 78px;
    overflow: hidden;
}

.service-item-card-wrap .service-item-image img {
    width: 100%;
}

.service-item-card-desc h6 {
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
}

.service-item-card-desc p {
    font-size: 12px;
    color: #626262;
    font-weight: 400;
    margin: 0px;
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limit the text to 2 lines */
    -webkit-box-orient: vertical;
}

.additional-services-card-wrap .service-item-card-desc p {
    color: #1A1919;
    /* white-space: nowrap; */
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
}


.info-icon-wrap {
    position: absolute;
    right: 10px;
    top: 8px;
    cursor: pointer;
    z-index: 2;
}


.add-cart-btn-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: #F3F3F3;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    right: -4px;
    min-width: 30px;
    min-height: 30px;
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 3px 6px #00000029;
    cursor: pointer;
}

.card-delet-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.card-delet-icon:hover{
    background: #cccccc3b;
}

.plus-icon-wrap:hover{
    background: #cccccc3b;
}

.add-cart-btn-wrap.add-cart-withextra:hover{
    background: #eaeaea;
}

.plus-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.add-cart-btn-wrap img {
    width: 10px !important;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.add-cart-btn-wrap.remove-cart-item-btn img {
    opacity: 1;
}

img.delete-icon {
    width: 14px !important;
}

img.delete-icon.decrement-icon {
    width: 8px !important;
    height: 3px;
    object-fit: cover;
}

.add-cart-btn-wrap span {
    width: 16px;
    text-align: center;
    font-size: 14px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.add-cart-btn-wrap.expanded {
    border-radius: 20px;
    /* padding: 2px 12px;  */
}

.add-cart-btn-wrap.expanded .delete-icon,
.add-cart-btn-wrap.expanded .quantity {
    opacity: 1;
}

.plus-icon {
    opacity: 1 !important;
}

.slick-prev:before, .slick-next:before {
    font-size: 30px !important;
    line-height: 1;
    opacity: .75;
    color: #ccc !important;
    display: none;
}

.slick-prev, .slick-next {
    z-index: 99;
}

.slick-arrow.slick-next img, .slick-arrow.slick-prev img {
    width: 30px;
}

.slick-next {
    right: -6px !important;
}

.slick-prev {
    left: -15px !important;
}

.service-item-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* gap: 20px; */
}

.service-item-grid .service-item-card-wrap{
    margin-bottom: 20px;
}

/* .service-item-card-wrap.extra-service-item-wrap {
    margin-top: 20px;
} */

.service-items-main-wrap.extra-service-item-wrap {
    margin-top: 0px !important;
}


.explore-speciality-services-wrap {
    height: 62px;
    background: #F3F3F3;
    border-radius: 9px;
    padding: 10px;
    margin-top: 18px;
    cursor: pointer;
}

.explore-speciality-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    height: 42px;
}

.explore-speciality-wrap h4 {
    font-size: 28px;
    color: #00A19B;
    font-weight: 600;
    margin: 0px;
}

.explore-speciality-wrap p {
    font-size: 12px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
}

.explore-speciality-wrap img {
    width: 28px;
}


.schedule-main-wrap h5 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    padding-bottom: 5px;
    padding-left: 10px;
}

.schedule-main-wrapper {
    margin-top: 16px;
    position: sticky;
    bottom: 0px;
    width: 100%;
    background-color: #fff;
    z-index: 999;
}


.date-and-time-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 6px;
}

.date-and-time-wrapper input {
    border: 1px solid #F3F3F3;
    border-radius: 9px;
    height: 62px;
    padding: 12px;
    width: 100%;
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
    outline: none;
    padding-left: 42px;
    padding-top: 24px;
}




.book-button-wrapper{
    margin-top: 18px;
}

.squrefeet-input-img img {
    width: 59px;
}

.login-option.sequirefeet-input-wrap{
    position: relative;
}


.login-option.sequirefeet-input-wrap .field label::before {
    left: 65px;
}

.login-option.sequirefeet-input-wrap .label-before, .field input:focus + label::before, .field input:valid + label::before {
    left: 9px !important;
}

.squrefeet-input-img {
    position: absolute;
    top: 14px;
    z-index: 99;
}


.date-input-wrap {
    position: relative;
    width: 50%;
}

.time-input-wrap {
    position: relative;
    width: 50%;
}

.time-input-wrap img{
    position: absolute;
    top: 18px;
    right: 12px;
    z-index: 99;
    cursor: pointer;
}

.date-input-wrap img {
    position: absolute;
    width: 35px;
    top: 10px;
    left: 4px;
    z-index: 99;
    cursor: pointer;
}

.custom-date-input p {
    position: absolute;
    left: 42px;
    top: 10px;
    font-size: 12px;
    color: #626262;
    font-weight: 400;
}

.custom-date-input input::placeholder{
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
}

/****** Speciality service page css *******/
.special-service-detail-left {
    position: relative;
    /* min-height: calc(100vh - 280px); */
    /* height: 660px; */
}

/* .specaility-schedule-wrap{
    width: 93%;
    position: absolute;
    bottom: 0px;
} */

.specaility-schedule-wrap{
    margin-top: 16px;
    position: sticky;
    bottom: 0px;
    width: 98%;
    background-color: #fff;
    z-index: 999;
}


.special-service-select-wrap {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 100px;
    margin-top: 30px;
}

.special-service-image-wrap{
    width: 88px;
}

.special-service-image-wrap img {
    width: 88px;
    cursor: pointer;
}

.service-select-wrap h3 {
    font-size: 22px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.special-service-image-wrap h4 {
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
    text-align: center;
}

.special-service-image-wrap.active h4 {
    color: #00A19B;
}

.special-service-image-wrap{
    opacity: 0.6;
}

.special-service-image-wrap.active{
    opacity: 1;
}

p.sq-placeholder {
    position: absolute;
    top: 20px;
    right: 12px;
    font-size: 14px;
    color: #00a19b !important;
    font-weight: 600;
}



.info-icon-wrap img {
    width: 10px;
    height: 10px;
}

.react-datepicker-wrapper {
    width: 100%;
}

.time-input-wrap {
    display: inline-block;
  }
  
  .time-input-label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .timepicker-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  

  .address-city-postal-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

    .address-city-postal-wrapper .select-box-wrapper {
        margin-top: 0px !important;
        width: 100%;
    }

    .postal-code-option{
        width: 100%;
    }

  .postal-code-option input {
    width: 100%;
    height: 62px;
    line-height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    color: #1A1919;
    border: 1px solid #f3f3f3;
    border-radius: 9px;
    margin: 0px;
    font-weight: 500;
    /* z-index: 22; */
    position: relative;
    background-color: transparent;
    outline: none;
}

.postal-code-option label {
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
    margin-bottom: 6px;
    padding-left: 10px;
}

.postal-code-option input::placeholder{
    opacity: 0.6;
}

h3.for-desktop-view {
    display: block;
}

h3.for-mobile-view{
    display: none;
}


.service-item-card-wrap.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  
  .service-item-card-wrap.disabled .add-cart-btn-wrap {
    pointer-events: none;
  }

.service-item-card-wrapper .slick-track {
    padding-top: 2px;
    margin-left: unset !important;
}

.service-item-card-wrap:hover {
    border: 1px solid #00A19B;
    transform: translateY(-2px);
}

.squareFeet-Slider-wrap{
    margin-bottom: 16px;
}


.flooring-slider-info-wrap{
    display: flex;
    gap: 6px;
  }
  
  .flooring-slider-info-wrap img{
    margin-top: -2px;
    cursor: pointer;
    width: 10px;
  }
  

/******* Resposive css ****/
@media (max-width: 1024px) {
    .dashboard-services-main-wrapper {
        margin-top: 22px;
    }

    .dashboard-service-detail-wrapper {
        margin-top: 20px;
    }

    .service-header-left h3 {
        font-size: 20px;
        margin-bottom: 0px;
    }

    .service-header-right {
        display: none;
    }

    .service-header-wrap{
        display: unset;
    }

    .service-header-left {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .service-header-reating p {
        font-size: 14px;
    }

    .service-header-reating img {
        width: 24px;
    }

    .address-detail-wrap {
        width: 100%;
        /* height: 212px; */
        height: auto;
        border: 2px solid #F8F8F8;
        border-radius: 20px;
        padding: 20px 18px;
    }

    .address-city-postal-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px
    }

    .service-select-images {
        display: none;
    }

    .service-select-wrap {
        width: 100%;
        height: auto;
        border: 2px solid #F8F8F8;
        border-radius: 20px;
        padding: 20px 18px;
        margin-top: 16px;
        margin-bottom: 100px;
    }

    .service-select-dropdown-wrap {
        margin-top: 0px;
    }

    .service-select-dropdown-wrap h4 {
        font-size: 16px;
        font-weight: 600;
    }

    /* .home-service-detail-main-wrapper {
        display: none;
    } */

    .mobile-continue-button{
        margin-top: 20px;
        position: sticky;
        bottom: 80px;
        width: 100%;
        background: #fff;
        padding-bottom: 10px;
    }

    .selected-service-detail-wrap {
        grid-template-columns: 100%;
        gap: 20px;
    }
    
    .mobile-selected-service-detail-wrap {
        margin-top: 20px;
        margin-bottom: 100px;
    }

    .mobile-service-back-wrap {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
    }

    .mobile-service-back-wrap h3 {
        font-size: 20px;
        color: #1A1919;
        font-weight: bold;
        margin: 0pc;
    }

    .squrefeet-input-img {
        position: absolute;
        top: 24px;
        z-index: 99;
    }

    .squrefeet-input-img img {
        width: 51px;
    }

    .home-cleaning-persentage-warpper {
        margin-top: 40px;
    }

    .flooring-slider-wrap {
        margin-top: 20px;
    }

    .cleaning-persentage-info h4 {
        font-size: 16px;
    }

    .cleaning-name-wrap {
        position: absolute;
        top: 4px;
        left: 18px;
    }

    .cleaning-reverse-name-wrap {
        position: absolute;
        top: 4px;
        right: 18px;
    }

    .flooring-slider-wrap .chart-and-image-wrap {
        width: 50px;
    }

    .service-item-image {
        position: relative;
        height: 110px;
        width: 110px;
        margin: 0 auto;
    }

    .service-item-img{
        height: 110px;
        width: 110px;
    }

    .slick-prev, .slick-next {
        display: none !important;
    }

    .service-item-card-desc h6 {
        font-size: 18px;
        font-weight: 400;
        color: #1A1919;
        margin-bottom: 4px;
    }

    .service-items-main-wrap {
        margin-top: 20px;
    }

    .service-items-main-wrap.extra-service-item-wrap {
        margin-top: 26px !important;
        border-top: 1px solid #E1E1E1;
        padding-top: 20px;
    }

    .special-extra-service-item-wrap.extra-service-item-wrap {
        margin-top: 0px !important;
        border-top: none;
        padding-top: 0px;
    }

    .explore-speciality-wrap {
        justify-content: space-between;
    }

    .mobile-explore-speciality-left {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .explore-speciality-services-wrap {
        margin-top: 26px;
        margin-bottom: 26px;
        cursor: pointer;
    }

    .book-button-wrapper button {
        height: 62px;
    }

    /* .book-button-wrapper {
        margin-top: 32px;
    } */

    .schedule-main-wrapper {
        position: sticky;
        bottom: 80px;
        padding-top: 16px;
        padding-bottom: 10px;
        margin-top: 0px;
        margin-bottom: 0px;
    }

    /* .book-button-wrapper{
        position: sticky;
        bottom: 80px;
        padding-top: 16px;
        padding-bottom: 10px;
        margin-top: 0px;
        margin-bottom: 0px;
        z-index: 999;
    } */

    h3.for-desktop-view {
        display: none;
    }

    h3.for-mobile-view{
        display: block;
    }

    .select-box-wrapper {
        margin-top: 16px;
    }

    .address-detail-wrap .field {
        margin-bottom: 16px;
    }

    .service-items-main-wrap h5 {
        font-size: 14px;
    }

    .date-and-time-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 4px;
    }

    .date-and-time-wrapper input::placeholder {
        font-weight: 500;
    }

    .address-form-input-wrapper {
        margin-top: 12px;
    }

    .service-item-card-wrapper .service-item-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
    }

    .service-item-card-wrap {
        width: 140px !important;
        height: 180px;
        justify-self: center;
        align-self: center;
    }
}


@media (max-width: 390px) {
    .service-item-card-wrap {
        width: 120px !important;
        height: 170px;
    }

    .service-item-image {
        position: relative;
        height: 96px;
        width: 90px;
        margin: 0 auto;
    }

    .service-item-img{
        height: 96px;
        width: 90px;
    }
}


@media (max-width: 360px) {
    .service-header-left h3 {
        font-size: 18px;
    }

    .service-header-reating {
        gap: 4px;
    }

    .service-header-reating p {
        font-size: 12px;
    }

    .service-item-card-wrap {
        width: 120px !important;
        height: 170px;
    }
}

@media (max-width: 330px) {
    .service-header-left h3 {
        font-size: 16px;
    }

    .service-header-reating {
        gap: 2px;
    }

    .service-header-reating p {
        font-size: 12px;
    }

    .service-header-reating img {
        width: 22px;
    }

    .service-item-card-wrap {
        width: 110px !important;
        height: 160px;
    }

    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {
        font-size: 12px;
    }

    .cleaning-name-wrap {
        left: 16px;
    }

    .cleaning-reverse-name-wrap {
        right: 16px;
    }

}

@media (min-width: 768px) and (max-width: 1024px) {
    .dashboard-service-detail-wrap .col-md-12.col-lg-4 {
        width: 100%;
    }

    .dashboard-service-detail-wrapper {
        margin-top: 20px;
        padding-bottom: 50px;
    }

    .slick-prev, .slick-next {
        display: block !important;
    }

    .service-item-card-wrapper .service-item-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        width: 100%;
    }

    .service-item-card-wrap {
        width: 140px !important;
        height: 180px;
        justify-self: center;
        align-self: center;
    }

/*     
    .explore-speciality-services-wrap {
        display: none;
    }

    .dashboard-services-main-wrapper {
        margin-top: 40px;
    }

    .service-select-dropdown-wrap h4 {
        font-size: 18px;
    }

    .address-detail-wrap h4 {
        font-size: 14px;
    }

    .service-header-left h3 {
        font-size: 24px;
    }

    .selected-service-title h3 {
        font-size: 20px;
    }

    .service-right-nav p {
        font-size: 14px;
    }

    .service-right-nav h6 {
        font-size: 14px;
    }
    
    .service-header-reating img {
        width: 30px;
    }

    .service-header-reating p {
        font-size: 18px;
    }

    .selected-service-title {
        margin-top: -40px;
        margin-bottom: 10px;
        padding-left: 20px;
    }

    .home-service-detail-main-wrap {
        border: 2px solid #F8F8F8;
        border-radius: 22px;
        padding: 20px 20px;
    }

    .home-sequare-feet-wrap h4 {
        font-size: 14px;
    }

    .service-select-images {
        display: none;
    }

    .address-detail-wrap {
        width: 100%;
        border-radius: 24px;
        padding: 20px;
    }

    .service-select-wrap {
        width: 100%;
        border: 2px solid #F8F8F8;
        border-radius: 24px;
        padding: 20px 20px;
        margin-top: 16px;
    }

    .service-select-dropdown-wrap {
        margin-top: 0px;
    }


    .login-option.sequirefeet-input-wrap .field label::before {
        left: 60px;
        width: 109px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cleaning-persentage-info h4 {
        font-size: 14px;
    }

    .flooring-slider-wrap h5.flooring-text {
        font-size: 12px;
    }

    .dusting-slider-wrap h5.dusting-text {
        font-size: 12px;
    }

    .service-items-main-wrap h5 {
        font-size: 12px;
    }

    .cleaning-name-wrap {
        top: 6px;
        left: 10px;
    }

    .cleaning-reverse-name-wrap {
        top: 6px;
        right: 10px;
    }

    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {
        font-size: 11px;
    }

    .chart-and-image-wrap {
        gap: 0px;
        width: 60px;
    }

    .chart-and-image-wrap img {
        width: 30px;
        display: none;
    }

    .range-container {
        padding: 0px;
        padding-top: 10px;
    }

    .service-item-card-wrap {
        width: 110px !important;
        height: 147px;
    }

    .slick-arrow.slick-next img, .slick-arrow.slick-prev img {
        width: 26px;
    }

    .cleaning-persentage-info {
        margin-top: 30px;
    }

    .squrefeet-input-img img {
        width: 55px;
        top: 24px;
    }

    .service-item-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0px;
    }

    .service-item-grid .service-item-card-wrap {
        margin-bottom: 20px;
    }

    .service-item-card-wrap.extra-service-item-wrap {
        margin-top: 0px;
    }  

    .selected-service-detail-wrap {
        display: grid;
        grid-template-columns: 100%;
        gap: 20px;
    }

    .selected-service-detail-left {
        width: 100%;
        border-right: none;
        padding-right: 0px;
    }

    .address-detail-wrapper{
        position: sticky;
        top: 150px;
    }

    .dashboard-service-detail-wrap .col-md-4.col-lg-4 {
        width: 42%;
    }

    .dashboard-service-detail-wrap .col-md-8.col-lg-8 {
        width: 58%;
    }

    .schedule-main-wrapper {
       position: unset;
    } */
  
}

@media (min-width: 1025px) and (max-width: 1199px) {
    .dashboard-services-main-wrapper {
        margin-top: 20px;
    }

    .service-select-dropdown-wrap h4 {
        font-size: 16px;
    }

    .service-header-left h3 {
        font-size: 20px;
    }

    .selected-service-title h3 {
        font-size: 22px;
    }

    .service-header-reating img {
        width: 27px;
    }

    .service-header-reating p {
        font-size: 14px;
    }

    .selected-service-title {
        margin-top: -40px;
        margin-bottom: 10px;
        padding-left: 20px;
    }

    .home-service-detail-main-wrap {
        border: 2px solid #F8F8F8;
        border-radius: 22px;
        /* min-height: 72vh; */
        height: 525px;
        padding: 20px 20px;
    }

    .empty-service-wrapper img {
        width: 120px;
    }

    .empty-service-wrapper p {
        font-size: 14px;
    }

    .home-sequare-feet-wrap h4 {
        font-size: 16px;
    }

    .service-select-images {
        display: none;
    }

    .address-detail-wrap {
        width: 100%;
        height: auto;
        border-radius: 24px;
        padding: 15px 19px;
    }

    .address-detail-wrap h4 {
        font-size: 14px;
    }

    .service-select-wrap {
        width: 100%;
        height: auto;
        border: 2px solid #F8F8F8;
        border-radius: 24px;
        padding: 20px 30px;
        font-size: 16px;
        margin-top: 10px;
    }

    .service-items-main-wrap.extra-service-item-wrap {
        margin-top: 0px !important;
        height: calc(100vh - 340px);
        overflow: auto;
    }

    .home-service-detail-main-wrap {
        padding: 20px 20px;
        margin-top: 20px;
    }

    .select-box-wrapper {
        margin-top: 10px;
    }

    .service-select-dropdown-wrap {
        margin-top: 0px;
    }


    .login-option.sequirefeet-input-wrap .field label::before {
        left: 50px;
        /* width: 200px; */
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cleaning-persentage-info h4 {
        font-size: 16px;
    }

    .cleaning-name-wrap {
        left: 18px;
    }

    .cleaning-reverse-name-wrap {
        right: 14px;
    }

    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {
        font-size: 11px;
    }

    .chart-and-image-wrap {
        gap: 0px;
        width: 60px;
    }

    .chart-and-image-wrap img {
        width: 30px;
        display: none;
    }

    .service-item-card-wrap {
        width: 120px !important;
        /* height: 140px; */
        height: 110px;
    }

    .cleaning-persentage-info {
        margin-top: 0px;
        display: none;
    }

    .squrefeet-input-img img {
        width: 40px;
        top: 20px;
    }

    .service-item-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0px;
    }

    .service-item-grid .service-item-card-wrap {
        margin-bottom: 14px;
    }

    .service-item-card-wrap.extra-service-item-wrap {
        margin-top: 0px;
    }

    .schedule-main-wrapper {
        padding-right: 20px;
    }

    .address-detail-wrap .field {
        margin-bottom: 2px;
    }

    .postal-code-option input {
        width: 100%;
        height: 48px;
        font-size: 12px;
    }

    .dashboard-service-detail-wrapper {
        margin-top: 16px;
    }

    .service-right-nav p {
        font-size: 14px;
    }

    .service-right-nav h6 {
        font-size: 14px;
    }

    p.sq-placeholder {
        top: 14px;
        font-size: 12px;
    }

    .flooring-slider-wrap h5.flooring-text {
        font-size: 12px;
    }

    .dusting-slider-wrap h5.dusting-text {
        font-size: 12px;
    }

    .service-items-main-wrap h5 {
        font-size: 12px;
    }

    .service-items-main-wrap {
        margin-top: 10px;
    }

    .service-item-card-wrapper {
        margin-top: 2px;
    }

    .service-item-card-wrapper.additional-services-card-wrap {
        margin-top: 4px;
    }

    .login-option.sequirefeet-input-wrap .field {
        margin-bottom: 10px;
    }

    .dusting-slider-wrap {
        margin-top: 10px;
    }

    .service-item-card-desc h6 {
        font-size: 12px;
    }

    .service-item-card-desc p {
        font-size: 12px;
    }

    .service-item-image {
        position: relative;
        height: 58px;
        width: 58px;
        margin: 0 auto;
    }

    .service-item-img{
        height: 58px;
        width: 58px;
    }

    .add-cart-btn-wrap {
        min-width: 24px;
        min-height: 24px;
    }

    .add-cart-btn-wrap img {
        width: 8px !important;
    }

    img.delete-icon {
        width: 12px !important;
    }

    .add-cart-btn-wrap span {
        width: 14px;
        text-align: center;
        font-size: 12px;
    }


    .plus-icon-wrap {
        width: 26px;
        height: 26px;
    }

    .card-delet-icon {
        width: 26px !important;
        height: 26px;
    }

    .date-and-time-wrapper input {
        height: 48px;
        font-size: 12px;
    }

    .custom-date-input p {
        top: 6px;
        font-size: 10px;
    }

    .time-input-wrap p {
        top: 6px;
        font-size: 10px;
    }

    .custom-date-input input::placeholder{
        font-size: 12px;
        color: #1A1919;
        font-weight: 500;
    }

    .book-button-wrapper {
        margin-top: 16px;
    }

    .book-button-wrapper button {
        height: 48px;
    }

    .schedule-main-wrap h5 {
        font-size: 12px;
        padding-bottom: 6px;
    }

    .service-items-main-wrap.extra-service-item-wrap h5 {
        font-size: 14px;
    }

    .date-and-time-wrapper {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-top: 4px;
    }

    .special-service-detail-left {
        position: relative;
        height: 480px;
        /* height: 480px;
        overflow: auto;
        padding-right: 0px; */
    }

    .home-service-detail-main-wrap .selected-service-detail-right {
        padding-right: 0px !important;
    }

    .squareFeet-Slider-wrap{
        margin-bottom: 8px;
    }
}

@media (min-width: 1200px) and (max-width: 1599px) {
    .create-order-header-wrap {
        border-bottom: none;
        padding-bottom: 0px !important;
        padding-top: 6px !important;
    }

    .service-select-dropdown-wrap h4 {
        font-size: 16px;
    }

    .service-header-left h3 {
        font-size: 22px;
    }

    .selected-service-title h3 {
        font-size: 22px;
    }

    .service-header-reating img {
        width: 27px;
    }

    .service-header-reating p {
        font-size: 14px;
    }

    .selected-service-title {
        margin-top: -40px;
        margin-bottom: 10px;
        padding-left: 20px;
    }

    .home-service-detail-main-wrap {
        border: 2px solid #F8F8F8;
        border-radius: 22px;
        /* min-height: 72vh; */
        height: 525px;
        padding: 20px 10px;
    }

    .empty-service-wrapper img {
        width: 120px;
    }

    .empty-service-wrapper p {
        font-size: 14px;
    }

    .home-sequare-feet-wrap h4 {
        font-size: 16px;
    }

    .service-select-images {
        display: none;
    }

    .address-detail-wrap {
        width: 100%;
        height: 196px;
        border-radius: 24px;
        padding: 15px 19px;
    }

    .address-detail-wrap h4 {
        font-size: 14px;
    }

    .service-select-wrap {
        width: 100%;
        height: 320px;
        border: 2px solid #F8F8F8;
        border-radius: 24px;
        padding: 20px 30px;
        font-size: 16px;
        margin-top: 10px;
    }

    .select-box-wrapper {
        margin-top: 10px;
    }

    .service-select-dropdown-wrap {
        margin-top: 0px;
    }


    .login-option.sequirefeet-input-wrap .field label::before {
        left: 50px;
        /* width: 160px; */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
    }

    .cleaning-persentage-info h4 {
        font-size: 16px;
    }

    .cleaning-name-wrap {
        left: 20px;
    }

    .cleaning-reverse-name-wrap {
        right: 20px;
    }

    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {
        font-size: 12px;
    }

    .chart-and-image-wrap {
        gap: 0px;
        width: 60px;
    }

    .chart-and-image-wrap img {
        width: 30px;
        display: none;
    }

    .service-item-card-wrap {
        width: 100px !important;
        /* height: 140px; */
        height: 110px;
    }

    .selected-service-detail-left {
        padding-right: 10px;
    }

    .selected-service-detail-wrap {
        gap: 10px;
    }

    .cleaning-persentage-info {
        margin-top: 0px;
        display: none;
    }

    .squrefeet-input-img img {
        width: 40px;
        top: 20px;
    }

    .service-item-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 0px;
    }

    .service-item-grid .service-item-card-wrap {
        margin-bottom: 14px;
    }

    .service-item-card-wrap.extra-service-item-wrap {
        margin-top: 0px;
    }

    .schedule-main-wrapper {
        padding-right: 20px;
    }

    .specaility-schedule-wrap {
        width: 100%;
    }

    .address-detail-wrap .field {
        margin-bottom: 2px;
    }

    .postal-code-option input {
        width: 100%;
        height: 48px;
        font-size: 12px;
    }

    .dashboard-service-detail-wrapper {
        margin-top: 6px;
    }

    .service-right-nav p {
        font-size: 14px;
    }

    .service-right-nav h6 {
        font-size: 14px;
    }

    p.sq-placeholder {
        top: 14px;
        font-size: 12px;
    }

    .flooring-slider-wrap h5.flooring-text {
        font-size: 12px;
    }

    .dusting-slider-wrap h5.dusting-text {
        font-size: 12px;
    }

    .service-items-main-wrap h5 {
        font-size: 12px;
    }

    .service-items-main-wrap {
        margin-top: 10px;
    }

    .service-item-card-wrapper {
        margin-top: 2px;
    }

    .service-item-card-wrapper.additional-services-card-wrap {
        margin-top: 4px;
    }

    .login-option.sequirefeet-input-wrap .field {
        margin-bottom: 10px;
    }

    .dusting-slider-wrap {
        margin-top: 10px;
    }

    .service-item-card-desc h6 {
        font-size: 12px;
    }

    .service-item-card-desc p {
        font-size: 12px;
    }

    .service-item-image {
        position: relative;
        height: 58px;
        width: 58px;
        margin: 0 auto;
    }

    .service-item-img{
        height: 58px;
        width: 58px;
    }

    .add-cart-btn-wrap {
        min-width: 24px;
        min-height: 24px;
    }

    .plus-icon-wrap {
        width: 26px;
        height: 26px;
    }

    .card-delet-icon {
        width: 26px !important;
        height: 26px;
    }

    .add-cart-btn-wrap img {
        width: 8px !important;
    }

    img.delete-icon {
        width: 12px !important;
    }

    .add-cart-btn-wrap span {
        width: 14px;
        text-align: center;
        font-size: 12px;
    }

    .card-delet-icon {
        width: 10px;
    }

    .date-and-time-wrapper input {
        height: 48px;
        font-size: 12px;
    }

    .custom-date-input p {
        top: 6px;
        font-size: 10px;
    }

    .time-input-wrap p {
        top: 6px;
        font-size: 10px;
    }

    .custom-date-input input::placeholder{
        font-size: 12px;
        color: #1A1919;
        font-weight: 500;
    }

    .book-button-wrapper {
        margin-top: 16px;
    }

    .book-button-wrapper button {
        height: 48px;
    }

    .schedule-main-wrap h5 {
        font-size: 12px;
        padding-bottom: 6px;
    }

    .service-items-main-wrap.extra-service-item-wrap h5 {
        font-size: 14px;
    }

    .special-service-detail-left {
        position: relative;
        height: 480px;
        /* height: 480px;
        overflow: auto;
        padding-right: 10px; */
    }

    .service-items-main-wrap.extra-service-item-wrap {
        margin-top: 0px !important;
        height: calc(100vh - 350px);
        overflow: auto;
    }

    .service-select-dropdown-wrap .select-box-wrapper {
        margin-top: 10px;
    }

    .field label::before {
        font-size: 12px;
        left: 20px;
    }

    .offer-and-benefits-wrapper {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .squareFeet-Slider-wrap{
        margin-bottom: 8px;
    }
}

@media (min-width: 1600px) and (max-width: 1899px) {
    .service-item-grid {
        gap: 0px;
    }

    .service-item-grid .service-item-card-wrap {
        margin-bottom: 20px;
    }

    .service-item-card-wrap.extra-service-item-wrap {
        margin-top: 0px;
    }
}

@media(min-width: 1600px){
    .service-header-left {
        display: flex;
        align-items: center;
        gap: 23px;
    }

    .home-service-detail-main-wrap {
        height: 724px !important;
        overflow: hidden;
        padding-right: 20px;
    }

    .home-service-detail-main-wrap .selected-service-detail-right {
        width: 100%;
        /* position: relative;
        height: 670px;
        overflow: auto; */
        /* padding-right: 20px; */
    }

    .service-items-main-wrap.extra-service-item-wrap {
        position: relative;
        height: 500px;
        overflow: auto;
    }

    .schedule-main-wrapper {
        padding-right: 20px;
    }

    .special-service-detail-left {
        position: relative;
        /* height: 670px;
        overflow: auto; */
    }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/CreateOrder/services.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;;GAEG;;AAEH;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;qBACiB;AACrB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB,EAAE,8BAA8B;IACrD,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;GAEG;;AAEH;IACI,0BAA0B;AAC9B;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;;;;AAKA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;;;;GAIG;;AAEH;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;IAEI;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;EAEF;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;AAEF;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;;AAGF,2BAA2B;AAC3B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;OAEG;;IAEH;QACI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;;OAEG;;IAEH;QACI,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;IACtB;;IAEA;;;;;;;;OAQG;;IAEH;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;;AAEJ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OAgMO;;AAEP;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,UAAU;QACV,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;;IAGA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb;;6BAEqB;IACzB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,UAAU;QACV,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;IAEA;QACI,aAAa;QACb,qCAAqC;QACrC,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb;;8BAEsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX;;yBAEiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB;yBACiB;IACrB;AACJ","sourcesContent":["\n.service-header-left {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.service-header-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.service-header-reating {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.service-header-reating img {\n    width: 33px;\n}\n\n.service-header-left h3 {\n    font-size: 38px;\n    color: #1A1919;\n    font-weight: bold;\n    margin: 0px;\n    /* margin-bottom: 14px; */\n}\n\n.service-header-reating p {\n    font-size: 20px;\n    color: #626262;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.service-right-nav {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.service-right-nav p {\n    font-size: 16px;\n    color: #9E9E9E;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.service-right-nav img {\n    width: 6px;\n}\n\n.service-right-nav h6 {\n    font-size: 16px;\n    color: #00A19B;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.dashboard-service-detail-wrapper {\n    margin-top: 25px;\n}\n\n.address-detail-wrap {\n    width: 100%;\n    height: 259px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 30px 34px;\n}\n\n.address-detail-wrap .field{\n    margin-bottom: 14px;\n}\n\n.address-detail-wrap h4 {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    margin-left: 10px;\n}\n\n.service-select-wrap{\n    width: 100%;\n    height: 444px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 32px 36px;\n    margin-top: 20px;\n}\n\n.home-service-detail-main-wrap {\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    /* min-height: 72vh; */\n    padding: 25px 40px;\n}\n\n.address-form-input-wrapper{\n    margin-top: 10px;\n}\n\n.address-form-input-wrap{\n    position: relative;\n    width: 100%;\n    height: 62px;\n    margin-bottom: 16px;\n}\n\n.address-form-input-wrap input {\n    width: 100%;\n    height: 62px;\n    border: 1px solid #F3F3F3;\n    border-radius: 9px;\n    padding-left: 25px;\n    padding-top: 20px;\n    outline: none;\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n}\n\n.address-form-input-wrap input::placeholder{\n    color: #1A1919; \n}\n\n.login-form-textarea-wrap{\n    height: 236px;  \n}\n\n\n.address-form-input-wrap label {\n    position: absolute;\n    top: 10px;\n    left: 25px;\n    font-size: 12px;\n    font-weight: 400;\n    color: #626262;\n}\n\n.service-select-images {\n    display: flex;\n    justify-content: space-between;\n}\n\n.service-select-images img {\n    width: 92px;\n}\n\n/* .service-select-dropdown-wrap {\n    margin-top: 28px;\n} */\n\n.service-select-dropdown-wrap h4 {\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n    margin-left: 10px;\n}\n\n.empty-service-wrapper {\n    display: flex;\n    gap: 20px;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 58vh;\n    align-items: center;\n}\n\n.empty-service-wrapper img {\n    width: 170px;\n}\n\n.empty-service-wrapper p {\n    font-size: 16px;\n    color: #9E9E9E;\n    font-weight: 600;\n    margin: 0px;\n    font-style: italic;\n}\n\n.selected-service-title{\n    margin-top: -60px;\n    margin-bottom: 20px;\n    padding-left: 40px;\n}\n\n.selected-service-title h3{\n    font-size: 30px;\n    color: #1A1919;\n    font-weight: bold;\n    margin: 0px;\n}\n\n.selected-service-detail-wrap {\n    display: grid;\n    /* grid-template-columns: auto auto; */\n    grid-template-columns: 50% 50%;\n    gap: 20px;\n}\n\n.selected-service-detail-wrap.fullscreen {\n    grid-template-columns: 100%;\n}\n\n.selected-service-detail-left{\n    width: 100%;\n    border-right: 1px solid #F3F3F3;\n    padding-right: 20px;\n}\n\n.special-service-detail-left{\n    padding-right: 0px !important;\n}\n\n.selected-service-detail-right{\n    width: 100%;\n    position: relative;\n    /* height: 670px;\n    overflow: auto; */\n}\n\n.home-sequare-feet-wrap h4\n {\n    font-size: 18px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    padding-bottom: 16px;\n    padding-left: 10px;\n}\n\n.cleaning-persentage-info {\n    display: flex;\n    align-items: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.cleaning-persentage-info h4\n {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    padding-left: 10px;\n}\n\n.cleaning-persentage-info img{\n    cursor: pointer;\n}\n\n.service-item-card-wrapper {\n    margin-top: 10px;\n    gap: 20px;\n}\n\n.service-item-card-wrapper.additional-services-card-wrap {\n    margin-top: 12px;\n}\n\n.service-items-main-wrap {\n    margin-top: 20px;\n}\n\n.service-items-main-wrap h5{\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    padding-bottom: 3px;\n    padding-left: 10px;\n}\n\n.service-item-card-wrap {\n    width: 103px !important;\n    height: 134px;\n    border: 1px solid #F3F3F3;\n    border-radius: 15px;\n    padding: 6px 12px;\n    position: relative;\n    transition: transform 0.3s ease;\n}\n\n.service-item-image {\n    position: relative;\n    height: 78px;\n    width: 78px;\n}\n\n.service-item-img{\n    /* padding-top: 10px; */\n    height: 78px;\n    width: 78px;\n    overflow: hidden;\n}\n\n.service-item-card-wrap .service-item-image img {\n    width: 100%;\n}\n\n.service-item-card-desc h6 {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.service-item-card-desc p {\n    font-size: 12px;\n    color: #626262;\n    font-weight: 400;\n    margin: 0px;\n    width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* Limit the text to 2 lines */\n    -webkit-box-orient: vertical;\n}\n\n.additional-services-card-wrap .service-item-card-desc p {\n    color: #1A1919;\n    /* white-space: nowrap; */\n    width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n.info-icon-wrap {\n    position: absolute;\n    right: 10px;\n    top: 8px;\n    cursor: pointer;\n    z-index: 2;\n}\n\n\n.add-cart-btn-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    background: #F3F3F3;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    right: -4px;\n    min-width: 30px;\n    min-height: 30px;\n    transition: all 0.2s ease-in-out;\n    box-shadow: 0px 3px 6px #00000029;\n    cursor: pointer;\n}\n\n.card-delet-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.card-delet-icon:hover{\n    background: #cccccc3b;\n}\n\n.plus-icon-wrap:hover{\n    background: #cccccc3b;\n}\n\n.add-cart-btn-wrap.add-cart-withextra:hover{\n    background: #eaeaea;\n}\n\n.plus-icon-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.add-cart-btn-wrap img {\n    width: 10px !important;\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n}\n\n.add-cart-btn-wrap.remove-cart-item-btn img {\n    opacity: 1;\n}\n\nimg.delete-icon {\n    width: 14px !important;\n}\n\nimg.delete-icon.decrement-icon {\n    width: 8px !important;\n    height: 3px;\n    object-fit: cover;\n}\n\n.add-cart-btn-wrap span {\n    width: 16px;\n    text-align: center;\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n}\n\n.add-cart-btn-wrap.expanded {\n    border-radius: 20px;\n    /* padding: 2px 12px;  */\n}\n\n.add-cart-btn-wrap.expanded .delete-icon,\n.add-cart-btn-wrap.expanded .quantity {\n    opacity: 1;\n}\n\n.plus-icon {\n    opacity: 1 !important;\n}\n\n.slick-prev:before, .slick-next:before {\n    font-size: 30px !important;\n    line-height: 1;\n    opacity: .75;\n    color: #ccc !important;\n    display: none;\n}\n\n.slick-prev, .slick-next {\n    z-index: 99;\n}\n\n.slick-arrow.slick-next img, .slick-arrow.slick-prev img {\n    width: 30px;\n}\n\n.slick-next {\n    right: -6px !important;\n}\n\n.slick-prev {\n    left: -15px !important;\n}\n\n.service-item-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    /* gap: 20px; */\n}\n\n.service-item-grid .service-item-card-wrap{\n    margin-bottom: 20px;\n}\n\n/* .service-item-card-wrap.extra-service-item-wrap {\n    margin-top: 20px;\n} */\n\n.service-items-main-wrap.extra-service-item-wrap {\n    margin-top: 0px !important;\n}\n\n\n.explore-speciality-services-wrap {\n    height: 62px;\n    background: #F3F3F3;\n    border-radius: 9px;\n    padding: 10px;\n    margin-top: 18px;\n    cursor: pointer;\n}\n\n.explore-speciality-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    height: 42px;\n}\n\n.explore-speciality-wrap h4 {\n    font-size: 28px;\n    color: #00A19B;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.explore-speciality-wrap p {\n    font-size: 12px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.explore-speciality-wrap img {\n    width: 28px;\n}\n\n\n.schedule-main-wrap h5 {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    padding-bottom: 5px;\n    padding-left: 10px;\n}\n\n.schedule-main-wrapper {\n    margin-top: 16px;\n    position: sticky;\n    bottom: 0px;\n    width: 100%;\n    background-color: #fff;\n    z-index: 999;\n}\n\n\n.date-and-time-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-top: 6px;\n}\n\n.date-and-time-wrapper input {\n    border: 1px solid #F3F3F3;\n    border-radius: 9px;\n    height: 62px;\n    padding: 12px;\n    width: 100%;\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n    outline: none;\n    padding-left: 42px;\n    padding-top: 24px;\n}\n\n\n\n\n.book-button-wrapper{\n    margin-top: 18px;\n}\n\n.squrefeet-input-img img {\n    width: 59px;\n}\n\n.login-option.sequirefeet-input-wrap{\n    position: relative;\n}\n\n\n.login-option.sequirefeet-input-wrap .field label::before {\n    left: 65px;\n}\n\n.login-option.sequirefeet-input-wrap .label-before, .field input:focus + label::before, .field input:valid + label::before {\n    left: 9px !important;\n}\n\n.squrefeet-input-img {\n    position: absolute;\n    top: 14px;\n    z-index: 99;\n}\n\n\n.date-input-wrap {\n    position: relative;\n    width: 50%;\n}\n\n.time-input-wrap {\n    position: relative;\n    width: 50%;\n}\n\n.time-input-wrap img{\n    position: absolute;\n    top: 18px;\n    right: 12px;\n    z-index: 99;\n    cursor: pointer;\n}\n\n.date-input-wrap img {\n    position: absolute;\n    width: 35px;\n    top: 10px;\n    left: 4px;\n    z-index: 99;\n    cursor: pointer;\n}\n\n.custom-date-input p {\n    position: absolute;\n    left: 42px;\n    top: 10px;\n    font-size: 12px;\n    color: #626262;\n    font-weight: 400;\n}\n\n.custom-date-input input::placeholder{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n}\n\n/****** Speciality service page css *******/\n.special-service-detail-left {\n    position: relative;\n    /* min-height: calc(100vh - 280px); */\n    /* height: 660px; */\n}\n\n/* .specaility-schedule-wrap{\n    width: 93%;\n    position: absolute;\n    bottom: 0px;\n} */\n\n.specaility-schedule-wrap{\n    margin-top: 16px;\n    position: sticky;\n    bottom: 0px;\n    width: 98%;\n    background-color: #fff;\n    z-index: 999;\n}\n\n\n.special-service-select-wrap {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 100px;\n    margin-top: 30px;\n}\n\n.special-service-image-wrap{\n    width: 88px;\n}\n\n.special-service-image-wrap img {\n    width: 88px;\n    cursor: pointer;\n}\n\n.service-select-wrap h3 {\n    font-size: 22px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.special-service-image-wrap h4 {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n    text-align: center;\n}\n\n.special-service-image-wrap.active h4 {\n    color: #00A19B;\n}\n\n.special-service-image-wrap{\n    opacity: 0.6;\n}\n\n.special-service-image-wrap.active{\n    opacity: 1;\n}\n\np.sq-placeholder {\n    position: absolute;\n    top: 20px;\n    right: 12px;\n    font-size: 14px;\n    color: #00a19b !important;\n    font-weight: 600;\n}\n\n\n\n.info-icon-wrap img {\n    width: 10px;\n    height: 10px;\n}\n\n.react-datepicker-wrapper {\n    width: 100%;\n}\n\n.time-input-wrap {\n    display: inline-block;\n  }\n  \n  .time-input-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n  \n  .timepicker-icon {\n    width: 20px;\n    height: 20px;\n    margin-right: 5px;\n  }\n  \n\n  .address-city-postal-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n    .address-city-postal-wrapper .select-box-wrapper {\n        margin-top: 0px !important;\n        width: 100%;\n    }\n\n    .postal-code-option{\n        width: 100%;\n    }\n\n  .postal-code-option input {\n    width: 100%;\n    height: 62px;\n    line-height: 40px;\n    padding: 0 15px;\n    box-sizing: border-box;\n    font-size: 14px;\n    color: #1A1919;\n    border: 1px solid #f3f3f3;\n    border-radius: 9px;\n    margin: 0px;\n    font-weight: 500;\n    /* z-index: 22; */\n    position: relative;\n    background-color: transparent;\n    outline: none;\n}\n\n.postal-code-option label {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n    margin-bottom: 6px;\n    padding-left: 10px;\n}\n\n.postal-code-option input::placeholder{\n    opacity: 0.6;\n}\n\nh3.for-desktop-view {\n    display: block;\n}\n\nh3.for-mobile-view{\n    display: none;\n}\n\n\n.service-item-card-wrap.disabled {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n  \n  .service-item-card-wrap.disabled .add-cart-btn-wrap {\n    pointer-events: none;\n  }\n\n.service-item-card-wrapper .slick-track {\n    padding-top: 2px;\n    margin-left: unset !important;\n}\n\n.service-item-card-wrap:hover {\n    border: 1px solid #00A19B;\n    transform: translateY(-2px);\n}\n\n.squareFeet-Slider-wrap{\n    margin-bottom: 16px;\n}\n\n\n.flooring-slider-info-wrap{\n    display: flex;\n    gap: 6px;\n  }\n  \n  .flooring-slider-info-wrap img{\n    margin-top: -2px;\n    cursor: pointer;\n    width: 10px;\n  }\n  \n\n/******* Resposive css ****/\n@media (max-width: 1024px) {\n    .dashboard-services-main-wrapper {\n        margin-top: 22px;\n    }\n\n    .dashboard-service-detail-wrapper {\n        margin-top: 20px;\n    }\n\n    .service-header-left h3 {\n        font-size: 20px;\n        margin-bottom: 0px;\n    }\n\n    .service-header-right {\n        display: none;\n    }\n\n    .service-header-wrap{\n        display: unset;\n    }\n\n    .service-header-left {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .service-header-reating p {\n        font-size: 14px;\n    }\n\n    .service-header-reating img {\n        width: 24px;\n    }\n\n    .address-detail-wrap {\n        width: 100%;\n        /* height: 212px; */\n        height: auto;\n        border: 2px solid #F8F8F8;\n        border-radius: 20px;\n        padding: 20px 18px;\n    }\n\n    .address-city-postal-wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 16px\n    }\n\n    .service-select-images {\n        display: none;\n    }\n\n    .service-select-wrap {\n        width: 100%;\n        height: auto;\n        border: 2px solid #F8F8F8;\n        border-radius: 20px;\n        padding: 20px 18px;\n        margin-top: 16px;\n        margin-bottom: 100px;\n    }\n\n    .service-select-dropdown-wrap {\n        margin-top: 0px;\n    }\n\n    .service-select-dropdown-wrap h4 {\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    /* .home-service-detail-main-wrapper {\n        display: none;\n    } */\n\n    .mobile-continue-button{\n        margin-top: 20px;\n        position: sticky;\n        bottom: 80px;\n        width: 100%;\n        background: #fff;\n        padding-bottom: 10px;\n    }\n\n    .selected-service-detail-wrap {\n        grid-template-columns: 100%;\n        gap: 20px;\n    }\n    \n    .mobile-selected-service-detail-wrap {\n        margin-top: 20px;\n        margin-bottom: 100px;\n    }\n\n    .mobile-service-back-wrap {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 20px;\n    }\n\n    .mobile-service-back-wrap h3 {\n        font-size: 20px;\n        color: #1A1919;\n        font-weight: bold;\n        margin: 0pc;\n    }\n\n    .squrefeet-input-img {\n        position: absolute;\n        top: 24px;\n        z-index: 99;\n    }\n\n    .squrefeet-input-img img {\n        width: 51px;\n    }\n\n    .home-cleaning-persentage-warpper {\n        margin-top: 40px;\n    }\n\n    .flooring-slider-wrap {\n        margin-top: 20px;\n    }\n\n    .cleaning-persentage-info h4 {\n        font-size: 16px;\n    }\n\n    .cleaning-name-wrap {\n        position: absolute;\n        top: 4px;\n        left: 18px;\n    }\n\n    .cleaning-reverse-name-wrap {\n        position: absolute;\n        top: 4px;\n        right: 18px;\n    }\n\n    .flooring-slider-wrap .chart-and-image-wrap {\n        width: 50px;\n    }\n\n    .service-item-image {\n        position: relative;\n        height: 110px;\n        width: 110px;\n        margin: 0 auto;\n    }\n\n    .service-item-img{\n        height: 110px;\n        width: 110px;\n    }\n\n    .slick-prev, .slick-next {\n        display: none !important;\n    }\n\n    .service-item-card-desc h6 {\n        font-size: 18px;\n        font-weight: 400;\n        color: #1A1919;\n        margin-bottom: 4px;\n    }\n\n    .service-items-main-wrap {\n        margin-top: 20px;\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap {\n        margin-top: 26px !important;\n        border-top: 1px solid #E1E1E1;\n        padding-top: 20px;\n    }\n\n    .special-extra-service-item-wrap.extra-service-item-wrap {\n        margin-top: 0px !important;\n        border-top: none;\n        padding-top: 0px;\n    }\n\n    .explore-speciality-wrap {\n        justify-content: space-between;\n    }\n\n    .mobile-explore-speciality-left {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .explore-speciality-services-wrap {\n        margin-top: 26px;\n        margin-bottom: 26px;\n        cursor: pointer;\n    }\n\n    .book-button-wrapper button {\n        height: 62px;\n    }\n\n    /* .book-button-wrapper {\n        margin-top: 32px;\n    } */\n\n    .schedule-main-wrapper {\n        position: sticky;\n        bottom: 80px;\n        padding-top: 16px;\n        padding-bottom: 10px;\n        margin-top: 0px;\n        margin-bottom: 0px;\n    }\n\n    /* .book-button-wrapper{\n        position: sticky;\n        bottom: 80px;\n        padding-top: 16px;\n        padding-bottom: 10px;\n        margin-top: 0px;\n        margin-bottom: 0px;\n        z-index: 999;\n    } */\n\n    h3.for-desktop-view {\n        display: none;\n    }\n\n    h3.for-mobile-view{\n        display: block;\n    }\n\n    .select-box-wrapper {\n        margin-top: 16px;\n    }\n\n    .address-detail-wrap .field {\n        margin-bottom: 16px;\n    }\n\n    .service-items-main-wrap h5 {\n        font-size: 14px;\n    }\n\n    .date-and-time-wrapper {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-top: 4px;\n    }\n\n    .date-and-time-wrapper input::placeholder {\n        font-weight: 500;\n    }\n\n    .address-form-input-wrapper {\n        margin-top: 12px;\n    }\n\n    .service-item-card-wrapper .service-item-grid {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        width: 100%;\n    }\n\n    .service-item-card-wrap {\n        width: 140px !important;\n        height: 180px;\n        justify-self: center;\n        align-self: center;\n    }\n}\n\n\n@media (max-width: 390px) {\n    .service-item-card-wrap {\n        width: 120px !important;\n        height: 170px;\n    }\n\n    .service-item-image {\n        position: relative;\n        height: 96px;\n        width: 90px;\n        margin: 0 auto;\n    }\n\n    .service-item-img{\n        height: 96px;\n        width: 90px;\n    }\n}\n\n\n@media (max-width: 360px) {\n    .service-header-left h3 {\n        font-size: 18px;\n    }\n\n    .service-header-reating {\n        gap: 4px;\n    }\n\n    .service-header-reating p {\n        font-size: 12px;\n    }\n\n    .service-item-card-wrap {\n        width: 120px !important;\n        height: 170px;\n    }\n}\n\n@media (max-width: 330px) {\n    .service-header-left h3 {\n        font-size: 16px;\n    }\n\n    .service-header-reating {\n        gap: 2px;\n    }\n\n    .service-header-reating p {\n        font-size: 12px;\n    }\n\n    .service-header-reating img {\n        width: 22px;\n    }\n\n    .service-item-card-wrap {\n        width: 110px !important;\n        height: 160px;\n    }\n\n    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {\n        font-size: 12px;\n    }\n\n    .cleaning-name-wrap {\n        left: 16px;\n    }\n\n    .cleaning-reverse-name-wrap {\n        right: 16px;\n    }\n\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .dashboard-service-detail-wrap .col-md-12.col-lg-4 {\n        width: 100%;\n    }\n\n    .dashboard-service-detail-wrapper {\n        margin-top: 20px;\n        padding-bottom: 50px;\n    }\n\n    .slick-prev, .slick-next {\n        display: block !important;\n    }\n\n    .service-item-card-wrapper .service-item-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        width: 100%;\n    }\n\n    .service-item-card-wrap {\n        width: 140px !important;\n        height: 180px;\n        justify-self: center;\n        align-self: center;\n    }\n\n/*     \n    .explore-speciality-services-wrap {\n        display: none;\n    }\n\n    .dashboard-services-main-wrapper {\n        margin-top: 40px;\n    }\n\n    .service-select-dropdown-wrap h4 {\n        font-size: 18px;\n    }\n\n    .address-detail-wrap h4 {\n        font-size: 14px;\n    }\n\n    .service-header-left h3 {\n        font-size: 24px;\n    }\n\n    .selected-service-title h3 {\n        font-size: 20px;\n    }\n\n    .service-right-nav p {\n        font-size: 14px;\n    }\n\n    .service-right-nav h6 {\n        font-size: 14px;\n    }\n    \n    .service-header-reating img {\n        width: 30px;\n    }\n\n    .service-header-reating p {\n        font-size: 18px;\n    }\n\n    .selected-service-title {\n        margin-top: -40px;\n        margin-bottom: 10px;\n        padding-left: 20px;\n    }\n\n    .home-service-detail-main-wrap {\n        border: 2px solid #F8F8F8;\n        border-radius: 22px;\n        padding: 20px 20px;\n    }\n\n    .home-sequare-feet-wrap h4 {\n        font-size: 14px;\n    }\n\n    .service-select-images {\n        display: none;\n    }\n\n    .address-detail-wrap {\n        width: 100%;\n        border-radius: 24px;\n        padding: 20px;\n    }\n\n    .service-select-wrap {\n        width: 100%;\n        border: 2px solid #F8F8F8;\n        border-radius: 24px;\n        padding: 20px 20px;\n        margin-top: 16px;\n    }\n\n    .service-select-dropdown-wrap {\n        margin-top: 0px;\n    }\n\n\n    .login-option.sequirefeet-input-wrap .field label::before {\n        left: 60px;\n        width: 109px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .cleaning-persentage-info h4 {\n        font-size: 14px;\n    }\n\n    .flooring-slider-wrap h5.flooring-text {\n        font-size: 12px;\n    }\n\n    .dusting-slider-wrap h5.dusting-text {\n        font-size: 12px;\n    }\n\n    .service-items-main-wrap h5 {\n        font-size: 12px;\n    }\n\n    .cleaning-name-wrap {\n        top: 6px;\n        left: 10px;\n    }\n\n    .cleaning-reverse-name-wrap {\n        top: 6px;\n        right: 10px;\n    }\n\n    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {\n        font-size: 11px;\n    }\n\n    .chart-and-image-wrap {\n        gap: 0px;\n        width: 60px;\n    }\n\n    .chart-and-image-wrap img {\n        width: 30px;\n        display: none;\n    }\n\n    .range-container {\n        padding: 0px;\n        padding-top: 10px;\n    }\n\n    .service-item-card-wrap {\n        width: 110px !important;\n        height: 147px;\n    }\n\n    .slick-arrow.slick-next img, .slick-arrow.slick-prev img {\n        width: 26px;\n    }\n\n    .cleaning-persentage-info {\n        margin-top: 30px;\n    }\n\n    .squrefeet-input-img img {\n        width: 55px;\n        top: 24px;\n    }\n\n    .service-item-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 0px;\n    }\n\n    .service-item-grid .service-item-card-wrap {\n        margin-bottom: 20px;\n    }\n\n    .service-item-card-wrap.extra-service-item-wrap {\n        margin-top: 0px;\n    }  \n\n    .selected-service-detail-wrap {\n        display: grid;\n        grid-template-columns: 100%;\n        gap: 20px;\n    }\n\n    .selected-service-detail-left {\n        width: 100%;\n        border-right: none;\n        padding-right: 0px;\n    }\n\n    .address-detail-wrapper{\n        position: sticky;\n        top: 150px;\n    }\n\n    .dashboard-service-detail-wrap .col-md-4.col-lg-4 {\n        width: 42%;\n    }\n\n    .dashboard-service-detail-wrap .col-md-8.col-lg-8 {\n        width: 58%;\n    }\n\n    .schedule-main-wrapper {\n       position: unset;\n    } */\n  \n}\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n    .dashboard-services-main-wrapper {\n        margin-top: 20px;\n    }\n\n    .service-select-dropdown-wrap h4 {\n        font-size: 16px;\n    }\n\n    .service-header-left h3 {\n        font-size: 20px;\n    }\n\n    .selected-service-title h3 {\n        font-size: 22px;\n    }\n\n    .service-header-reating img {\n        width: 27px;\n    }\n\n    .service-header-reating p {\n        font-size: 14px;\n    }\n\n    .selected-service-title {\n        margin-top: -40px;\n        margin-bottom: 10px;\n        padding-left: 20px;\n    }\n\n    .home-service-detail-main-wrap {\n        border: 2px solid #F8F8F8;\n        border-radius: 22px;\n        /* min-height: 72vh; */\n        height: 525px;\n        padding: 20px 20px;\n    }\n\n    .empty-service-wrapper img {\n        width: 120px;\n    }\n\n    .empty-service-wrapper p {\n        font-size: 14px;\n    }\n\n    .home-sequare-feet-wrap h4 {\n        font-size: 16px;\n    }\n\n    .service-select-images {\n        display: none;\n    }\n\n    .address-detail-wrap {\n        width: 100%;\n        height: auto;\n        border-radius: 24px;\n        padding: 15px 19px;\n    }\n\n    .address-detail-wrap h4 {\n        font-size: 14px;\n    }\n\n    .service-select-wrap {\n        width: 100%;\n        height: auto;\n        border: 2px solid #F8F8F8;\n        border-radius: 24px;\n        padding: 20px 30px;\n        font-size: 16px;\n        margin-top: 10px;\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap {\n        margin-top: 0px !important;\n        height: calc(100vh - 340px);\n        overflow: auto;\n    }\n\n    .home-service-detail-main-wrap {\n        padding: 20px 20px;\n        margin-top: 20px;\n    }\n\n    .select-box-wrapper {\n        margin-top: 10px;\n    }\n\n    .service-select-dropdown-wrap {\n        margin-top: 0px;\n    }\n\n\n    .login-option.sequirefeet-input-wrap .field label::before {\n        left: 50px;\n        /* width: 200px; */\n        font-size: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .cleaning-persentage-info h4 {\n        font-size: 16px;\n    }\n\n    .cleaning-name-wrap {\n        left: 18px;\n    }\n\n    .cleaning-reverse-name-wrap {\n        right: 14px;\n    }\n\n    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {\n        font-size: 11px;\n    }\n\n    .chart-and-image-wrap {\n        gap: 0px;\n        width: 60px;\n    }\n\n    .chart-and-image-wrap img {\n        width: 30px;\n        display: none;\n    }\n\n    .service-item-card-wrap {\n        width: 120px !important;\n        /* height: 140px; */\n        height: 110px;\n    }\n\n    .cleaning-persentage-info {\n        margin-top: 0px;\n        display: none;\n    }\n\n    .squrefeet-input-img img {\n        width: 40px;\n        top: 20px;\n    }\n\n    .service-item-grid {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 0px;\n    }\n\n    .service-item-grid .service-item-card-wrap {\n        margin-bottom: 14px;\n    }\n\n    .service-item-card-wrap.extra-service-item-wrap {\n        margin-top: 0px;\n    }\n\n    .schedule-main-wrapper {\n        padding-right: 20px;\n    }\n\n    .address-detail-wrap .field {\n        margin-bottom: 2px;\n    }\n\n    .postal-code-option input {\n        width: 100%;\n        height: 48px;\n        font-size: 12px;\n    }\n\n    .dashboard-service-detail-wrapper {\n        margin-top: 16px;\n    }\n\n    .service-right-nav p {\n        font-size: 14px;\n    }\n\n    .service-right-nav h6 {\n        font-size: 14px;\n    }\n\n    p.sq-placeholder {\n        top: 14px;\n        font-size: 12px;\n    }\n\n    .flooring-slider-wrap h5.flooring-text {\n        font-size: 12px;\n    }\n\n    .dusting-slider-wrap h5.dusting-text {\n        font-size: 12px;\n    }\n\n    .service-items-main-wrap h5 {\n        font-size: 12px;\n    }\n\n    .service-items-main-wrap {\n        margin-top: 10px;\n    }\n\n    .service-item-card-wrapper {\n        margin-top: 2px;\n    }\n\n    .service-item-card-wrapper.additional-services-card-wrap {\n        margin-top: 4px;\n    }\n\n    .login-option.sequirefeet-input-wrap .field {\n        margin-bottom: 10px;\n    }\n\n    .dusting-slider-wrap {\n        margin-top: 10px;\n    }\n\n    .service-item-card-desc h6 {\n        font-size: 12px;\n    }\n\n    .service-item-card-desc p {\n        font-size: 12px;\n    }\n\n    .service-item-image {\n        position: relative;\n        height: 58px;\n        width: 58px;\n        margin: 0 auto;\n    }\n\n    .service-item-img{\n        height: 58px;\n        width: 58px;\n    }\n\n    .add-cart-btn-wrap {\n        min-width: 24px;\n        min-height: 24px;\n    }\n\n    .add-cart-btn-wrap img {\n        width: 8px !important;\n    }\n\n    img.delete-icon {\n        width: 12px !important;\n    }\n\n    .add-cart-btn-wrap span {\n        width: 14px;\n        text-align: center;\n        font-size: 12px;\n    }\n\n\n    .plus-icon-wrap {\n        width: 26px;\n        height: 26px;\n    }\n\n    .card-delet-icon {\n        width: 26px !important;\n        height: 26px;\n    }\n\n    .date-and-time-wrapper input {\n        height: 48px;\n        font-size: 12px;\n    }\n\n    .custom-date-input p {\n        top: 6px;\n        font-size: 10px;\n    }\n\n    .time-input-wrap p {\n        top: 6px;\n        font-size: 10px;\n    }\n\n    .custom-date-input input::placeholder{\n        font-size: 12px;\n        color: #1A1919;\n        font-weight: 500;\n    }\n\n    .book-button-wrapper {\n        margin-top: 16px;\n    }\n\n    .book-button-wrapper button {\n        height: 48px;\n    }\n\n    .schedule-main-wrap h5 {\n        font-size: 12px;\n        padding-bottom: 6px;\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap h5 {\n        font-size: 14px;\n    }\n\n    .date-and-time-wrapper {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        margin-top: 4px;\n    }\n\n    .special-service-detail-left {\n        position: relative;\n        height: 480px;\n        /* height: 480px;\n        overflow: auto;\n        padding-right: 0px; */\n    }\n\n    .home-service-detail-main-wrap .selected-service-detail-right {\n        padding-right: 0px !important;\n    }\n\n    .squareFeet-Slider-wrap{\n        margin-bottom: 8px;\n    }\n}\n\n@media (min-width: 1200px) and (max-width: 1599px) {\n    .create-order-header-wrap {\n        border-bottom: none;\n        padding-bottom: 0px !important;\n        padding-top: 6px !important;\n    }\n\n    .service-select-dropdown-wrap h4 {\n        font-size: 16px;\n    }\n\n    .service-header-left h3 {\n        font-size: 22px;\n    }\n\n    .selected-service-title h3 {\n        font-size: 22px;\n    }\n\n    .service-header-reating img {\n        width: 27px;\n    }\n\n    .service-header-reating p {\n        font-size: 14px;\n    }\n\n    .selected-service-title {\n        margin-top: -40px;\n        margin-bottom: 10px;\n        padding-left: 20px;\n    }\n\n    .home-service-detail-main-wrap {\n        border: 2px solid #F8F8F8;\n        border-radius: 22px;\n        /* min-height: 72vh; */\n        height: 525px;\n        padding: 20px 10px;\n    }\n\n    .empty-service-wrapper img {\n        width: 120px;\n    }\n\n    .empty-service-wrapper p {\n        font-size: 14px;\n    }\n\n    .home-sequare-feet-wrap h4 {\n        font-size: 16px;\n    }\n\n    .service-select-images {\n        display: none;\n    }\n\n    .address-detail-wrap {\n        width: 100%;\n        height: 196px;\n        border-radius: 24px;\n        padding: 15px 19px;\n    }\n\n    .address-detail-wrap h4 {\n        font-size: 14px;\n    }\n\n    .service-select-wrap {\n        width: 100%;\n        height: 320px;\n        border: 2px solid #F8F8F8;\n        border-radius: 24px;\n        padding: 20px 30px;\n        font-size: 16px;\n        margin-top: 10px;\n    }\n\n    .select-box-wrapper {\n        margin-top: 10px;\n    }\n\n    .service-select-dropdown-wrap {\n        margin-top: 0px;\n    }\n\n\n    .login-option.sequirefeet-input-wrap .field label::before {\n        left: 50px;\n        /* width: 160px; */\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-size: 12px;\n    }\n\n    .cleaning-persentage-info h4 {\n        font-size: 16px;\n    }\n\n    .cleaning-name-wrap {\n        left: 20px;\n    }\n\n    .cleaning-reverse-name-wrap {\n        right: 20px;\n    }\n\n    .cleaning-name-wrap p, .cleaning-reverse-name-wrap p {\n        font-size: 12px;\n    }\n\n    .chart-and-image-wrap {\n        gap: 0px;\n        width: 60px;\n    }\n\n    .chart-and-image-wrap img {\n        width: 30px;\n        display: none;\n    }\n\n    .service-item-card-wrap {\n        width: 100px !important;\n        /* height: 140px; */\n        height: 110px;\n    }\n\n    .selected-service-detail-left {\n        padding-right: 10px;\n    }\n\n    .selected-service-detail-wrap {\n        gap: 10px;\n    }\n\n    .cleaning-persentage-info {\n        margin-top: 0px;\n        display: none;\n    }\n\n    .squrefeet-input-img img {\n        width: 40px;\n        top: 20px;\n    }\n\n    .service-item-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 0px;\n    }\n\n    .service-item-grid .service-item-card-wrap {\n        margin-bottom: 14px;\n    }\n\n    .service-item-card-wrap.extra-service-item-wrap {\n        margin-top: 0px;\n    }\n\n    .schedule-main-wrapper {\n        padding-right: 20px;\n    }\n\n    .specaility-schedule-wrap {\n        width: 100%;\n    }\n\n    .address-detail-wrap .field {\n        margin-bottom: 2px;\n    }\n\n    .postal-code-option input {\n        width: 100%;\n        height: 48px;\n        font-size: 12px;\n    }\n\n    .dashboard-service-detail-wrapper {\n        margin-top: 6px;\n    }\n\n    .service-right-nav p {\n        font-size: 14px;\n    }\n\n    .service-right-nav h6 {\n        font-size: 14px;\n    }\n\n    p.sq-placeholder {\n        top: 14px;\n        font-size: 12px;\n    }\n\n    .flooring-slider-wrap h5.flooring-text {\n        font-size: 12px;\n    }\n\n    .dusting-slider-wrap h5.dusting-text {\n        font-size: 12px;\n    }\n\n    .service-items-main-wrap h5 {\n        font-size: 12px;\n    }\n\n    .service-items-main-wrap {\n        margin-top: 10px;\n    }\n\n    .service-item-card-wrapper {\n        margin-top: 2px;\n    }\n\n    .service-item-card-wrapper.additional-services-card-wrap {\n        margin-top: 4px;\n    }\n\n    .login-option.sequirefeet-input-wrap .field {\n        margin-bottom: 10px;\n    }\n\n    .dusting-slider-wrap {\n        margin-top: 10px;\n    }\n\n    .service-item-card-desc h6 {\n        font-size: 12px;\n    }\n\n    .service-item-card-desc p {\n        font-size: 12px;\n    }\n\n    .service-item-image {\n        position: relative;\n        height: 58px;\n        width: 58px;\n        margin: 0 auto;\n    }\n\n    .service-item-img{\n        height: 58px;\n        width: 58px;\n    }\n\n    .add-cart-btn-wrap {\n        min-width: 24px;\n        min-height: 24px;\n    }\n\n    .plus-icon-wrap {\n        width: 26px;\n        height: 26px;\n    }\n\n    .card-delet-icon {\n        width: 26px !important;\n        height: 26px;\n    }\n\n    .add-cart-btn-wrap img {\n        width: 8px !important;\n    }\n\n    img.delete-icon {\n        width: 12px !important;\n    }\n\n    .add-cart-btn-wrap span {\n        width: 14px;\n        text-align: center;\n        font-size: 12px;\n    }\n\n    .card-delet-icon {\n        width: 10px;\n    }\n\n    .date-and-time-wrapper input {\n        height: 48px;\n        font-size: 12px;\n    }\n\n    .custom-date-input p {\n        top: 6px;\n        font-size: 10px;\n    }\n\n    .time-input-wrap p {\n        top: 6px;\n        font-size: 10px;\n    }\n\n    .custom-date-input input::placeholder{\n        font-size: 12px;\n        color: #1A1919;\n        font-weight: 500;\n    }\n\n    .book-button-wrapper {\n        margin-top: 16px;\n    }\n\n    .book-button-wrapper button {\n        height: 48px;\n    }\n\n    .schedule-main-wrap h5 {\n        font-size: 12px;\n        padding-bottom: 6px;\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap h5 {\n        font-size: 14px;\n    }\n\n    .special-service-detail-left {\n        position: relative;\n        height: 480px;\n        /* height: 480px;\n        overflow: auto;\n        padding-right: 10px; */\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap {\n        margin-top: 0px !important;\n        height: calc(100vh - 350px);\n        overflow: auto;\n    }\n\n    .service-select-dropdown-wrap .select-box-wrapper {\n        margin-top: 10px;\n    }\n\n    .field label::before {\n        font-size: 12px;\n        left: 20px;\n    }\n\n    .offer-and-benefits-wrapper {\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .squareFeet-Slider-wrap{\n        margin-bottom: 8px;\n    }\n}\n\n@media (min-width: 1600px) and (max-width: 1899px) {\n    .service-item-grid {\n        gap: 0px;\n    }\n\n    .service-item-grid .service-item-card-wrap {\n        margin-bottom: 20px;\n    }\n\n    .service-item-card-wrap.extra-service-item-wrap {\n        margin-top: 0px;\n    }\n}\n\n@media(min-width: 1600px){\n    .service-header-left {\n        display: flex;\n        align-items: center;\n        gap: 23px;\n    }\n\n    .home-service-detail-main-wrap {\n        height: 724px !important;\n        overflow: hidden;\n        padding-right: 20px;\n    }\n\n    .home-service-detail-main-wrap .selected-service-detail-right {\n        width: 100%;\n        /* position: relative;\n        height: 670px;\n        overflow: auto; */\n        /* padding-right: 20px; */\n    }\n\n    .service-items-main-wrap.extra-service-item-wrap {\n        position: relative;\n        height: 500px;\n        overflow: auto;\n    }\n\n    .schedule-main-wrapper {\n        padding-right: 20px;\n    }\n\n    .special-service-detail-left {\n        position: relative;\n        /* height: 670px;\n        overflow: auto; */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
